<div class="row" *ngIf="point">
  <json-edit
    [processing]="processing"
    [object]="point"
    [type]="'Inspection Point'"
    (toggleSave)="savePoint($event)"
    (toggleCancel)="cancel()"
  ></json-edit>
</div>
